export const DragToMoveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="64" viewBox="0 0 76 64" fill="none">
    <mask
      id="mask0_444_209"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="15"
      y="0"
      width="44"
      height="64"
    >
      <path
        d="M58.968 16.8551L58.611 25.0672C58.5681 26.0544 57.4066 26.5583 56.6563 25.9152C55.9439 25.3046 54.8382 25.725 54.7114 26.6547L52.0052 46.5L51.5163 49.1891C51.2417 50.6993 52.3218 52.1197 53.8505 52.2587C55.308 52.3912 56.3725 53.6948 56.2108 55.1494L55.7498 59.2987C55.6044 60.6072 54.6228 61.6681 53.3295 61.9144L45.4129 63.4223C45.1424 63.4739 44.8661 63.4879 44.5917 63.464L23.3602 61.6178C22.4991 61.5429 21.7121 61.1003 21.2009 60.4032L17.0592 54.7555C16.6985 54.2635 16.4963 53.6733 16.4796 53.0635L15.5282 18.3405C15.5132 17.7908 15.6495 17.2474 15.9224 16.7699L24.6415 1.51158C25.1756 0.576858 26.1696 0 27.2462 0H48.2507C49.3345 0 50.334 0.584588 50.8654 1.52922L58.5856 15.254C58.8599 15.7416 58.9923 16.2962 58.968 16.8551Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_444_209)">
      <rect
        x="18.7118"
        y="3.77965"
        width="37.9431"
        height="55.6152"
        rx="16.0153"
        stroke="#B9BCCB"
        strokeWidth="1.5593"
      />
      <line x1="18.5052" y1="26.2203" x2="44.5052" y2="26.2203" stroke="#B9BCCB" strokeWidth="1.5593" />
      <line
        x1="37.8138"
        y1="10.4622"
        x2="37.8138"
        y2="19.5279"
        stroke="#BB96FF"
        strokeWidth="2.83074"
        strokeLinecap="round"
      />
    </g>
    <path
      d="M44.8271 35.9937L44.0843 18.0387C44.0495 17.1983 44.3353 16.3792 44.8789 15.7615C45.4224 15.1437 46.1791 14.778 46.9825 14.7448C47.786 14.7115 48.5703 15.0135 49.163 15.5842C49.7557 16.1549 50.1082 16.9476 50.143 17.788L50.7984 33.6307"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.5422 29.1286C56.5422 28.3245 56.8616 27.5533 57.4302 26.9847C57.9988 26.4161 58.77 26.0967 59.5741 26.0967C60.3783 26.0967 61.1495 26.4161 61.7181 26.9847C62.2867 27.5533 62.6061 28.3245 62.6061 29.1286V32.1606"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.505 27.5612C50.505 26.7571 50.8244 25.9859 51.393 25.4173C51.9616 24.8487 52.7328 24.5293 53.5369 24.5293C54.341 24.5293 55.1122 24.8487 55.6808 25.4173C56.2494 25.9859 56.5689 26.7571 56.5689 27.5612V30.5932"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.6061 31.1501C62.6061 30.346 62.9256 29.5748 63.4942 29.0062C64.0628 28.4376 64.8339 28.1182 65.6381 28.1182C66.4422 28.1182 67.2134 28.4376 67.782 29.0062C68.3506 29.5748 68.67 30.346 68.67 31.1501V40.2459C68.67 43.4624 67.3923 46.5472 65.1179 48.8216C62.8435 51.096 59.7587 52.3737 56.5422 52.3737H52.4997H52.9201C50.9116 52.374 48.9345 51.8755 47.1662 50.923C45.398 49.9704 43.894 48.5936 42.7894 46.9162L42.3932 46.3098C41.7625 45.3416 39.2352 41.376 33.426 34.7313C33.0389 34.0431 32.9354 33.231 33.1378 32.4677C33.3401 31.7045 33.8322 31.0502 34.5095 30.6442C35.2308 30.2114 36.0761 30.032 36.9111 30.1345C37.746 30.2371 38.5228 30.6157 39.118 31.2102L44.4635 36.1478"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.36207 21.1349L1.06622 18.4576C0.815237 18.2538 0.805203 17.8741 1.04507 17.6572L4.19494 14.8096"
      stroke="#FFB4C9"
      strokeWidth="1.74275"
      strokeLinecap="round"
    />
    <path d="M10.6981 17.9521L2.69729 18.0135" stroke="#FFB4C9" strokeWidth="1.74275" strokeLinecap="round" />
    <path
      d="M70.8214 14.7157L74.1172 17.3929C74.3682 17.5968 74.3782 17.9765 74.1384 18.1934L70.9885 21.041"
      stroke="#FFB4C9"
      strokeWidth="1.74275"
      strokeLinecap="round"
    />
    <path d="M64.4852 17.8984L72.486 17.8371" stroke="#FFB4C9" strokeWidth="1.74275" strokeLinecap="round" />
  </svg>
);
